'use client';

import { Button } from '@mui/material';
import { IMonth } from 'my-poppies-b2b-types';

import { Container } from '@/components/Container';
import { PercentageDisplay } from '@/components/PercentageDisplay';
import { useAppPush } from '@/hooks/useAppPush';
import useTranslation from '@/hooks/useTranslation';
import { IMonthPaymentData } from '@/types/IMonthPaymentData';

interface IMonthlyPaymentRowProps {
  month: string;
  monthData: IMonthPaymentData;
}

export const MonthlyPaymentRow = ({ month, monthData }: IMonthlyPaymentRowProps) => {
  const t = useTranslation();
  const { push } = useAppPush();
  const { year, percentages } = monthData;

  return (
    <Container
      debugColor={'gold'}
      sx={{
        padding: '4px 16px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Container
        debugColor={'gray'}
        sx={{ marginRight: 8, width: 'unset', whiteSpace: 'nowrap', textAlign: 'left', flexGrow: 0 }}
      >
        {month}
        {percentages.TOTAL === 100 ? ` ${year}` : ''}
      </Container>
      <PercentageDisplay percent={percentages.TOTAL} />
      <Container
        debugColor={'blue'}
        sx={{ flexGrow: 1, flexBasis: undefined, display: 'flex', justifyContent: 'flex-end' }}
      >
        <Button
          onClick={() => {
            push(`/payments?month=${month as IMonth}`);
          }}
          sx={{ fontSize: `min(16px, 3dvw)` }}
        >
          {t('general.open')}
        </Button>
      </Container>
    </Container>
  );
};
